/**
 * PageHero: the header band from the system-wide refresh (26 Oct 2026, the
 * Bonsai Agents look) for working list pages. A slim moving gradient band
 * with an icon tile, gradient title, one-line subtitle and room on the right
 * for a figure or a button. Motion stops under prefers-reduced-motion (see
 * .cm-hero in index.css).
 */
export default function PageHero({ icon: Icon, title, subtitle, tile = "linear-gradient(135deg, #6366f1, #8b5cf6 55%, #ec4899)", children, testId }) {
  return (
    <div data-testid={testId}
      className="cm-hero relative rounded-2xl border border-white/10 px-5 py-4 mb-5 flex items-center justify-between flex-wrap gap-3 shadow-xl shadow-indigo-950/40">
      <div className="relative flex items-center gap-3 min-w-0">
        {Icon && (
          <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ring-1 ring-white/20 shadow-lg shadow-indigo-900/50"
            style={{ background: tile }}>
            <Icon className="w-5 h-5 text-white" aria-hidden="true" />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-xl font-bold agents-title leading-tight">{title}</h1>
          {subtitle && <p className="text-xs text-indigo-100/75 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {children && <div className="relative flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}
